<template>
  <v-container fluid style="width: 1140px; margin: 0 auto">
    <v-row>
      <v-col cols="12">
        <v-form @submit.prevent="searchPosts">
          <v-card elevation="0" tile outlined>
            <v-card-text>
              <div>1. 検索対象サイトを選んでください</div>
              <v-layout row>
                <v-select
                  v-model="siteKey"
                  :items="selectableSites"
                  item-text="name"
                  item-value="siteKey"
                  style="max-width: 150px"
                  class="ma-2"
                  clearable
                  label="対象サイト"
                />
              </v-layout>
              <v-divider />
              <div class="mt-3">2. 検索条件を入力してください</div>
              <v-layout row>
                <v-text-field
                  v-model="searchQuery.postIdEq"
                  label="記事ID"
                  style="max-width: 150px"
                  type="number"
                  clearable
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.postTitleCont"
                  label="タイトル"
                  style="max-width: 400px"
                  clearable
                  class="ma-2"
                />
                <v-select
                  v-model="searchQuery.statusEq"
                  :items="selectableStatuses"
                  item-text="type"
                  style="max-width: 150px"
                  class="ma-2"
                  item-value="value"
                  clearable
                  label="ステータス"
                />
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  class="ma-2"
                  type="submit"
                  @click="searchPosts"
                  @submit.prevent="searchPosts"
                >
                  検索
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <WriterOrderPostTable :orders="orders" :site="selectedSite()" />

        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Qs from 'qs'
import { mapState, mapGetters } from 'vuex'
import { deserialize } from 'deserialize-json-api'
import WriterOrderPostTable from '@/components/commons/WriterOrderPostTable'
import headUtilsMixin from '@/mixins/head_utils'
import orderUtils from '@/mixins/order_utils'

export default {
  name: 'Posts',
  components: {
    InfiniteLoading,
    WriterOrderPostTable
  },
  mixins: [headUtilsMixin, orderUtils],
  data: () => {
    return {
      pageTitle: '記事一覧',
      orders: [],
      page: 1,
      siteKey: null,
      searchQuery: {
        statusEq: null,
        statusNotEq: 0,
        postIdEq: '',
        postTitleCont: null
      },
      selectableStatuses: [
        { type: '執筆中', value: 10 },
        { type: '検収中', value: 30 },
        { type: 'ライター校了', value: 40 },
        { type: 'クライアント校了', value: 50 }
      ],
      orderStatusColors: {
        writing: 'primary',
        under_inspection: 'warning',
        completed: 'success'
      },
      infiniteId: +new Date()
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth
    }),
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  methods: {
    searchPosts () {
      this.page = 1
      this.orders = []
      this.infiniteId++
    },
    selectedSite () {
      return this.currentUserAuth.sites.find(
        (site) => site.siteKey === this.siteKey
      )
    },
    infiniteHandler ($state) {
      if (!this.siteKey) {
        $state.complete()
        return true
      }

      axios
        .get('/api/master/orders', {
          params: {
            page: this.page,
            site_key: this.siteKey,
            q: this.searchQuery
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedOrders = deserialize(data).data
          const activeOrders = fetchedOrders.filter(order => !this.isDeadOrder(order))
          if (activeOrders.length > 0) {
            this.page++
            this.orders = this.orders.concat(activeOrders)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    }
  }
}
</script>

<style scoped></style>
